import styled from "styled-components";

export const NumberWrapper = styled.div<{ isDisabled: boolean }>`
  max-width: 55px;
  min-width: 55px;

  opacity: ${(props) => (props.isDisabled ? "0.5" : "1")};
  pointer-events: ${(props) => (props.isDisabled ? "none" : "all")};
`;
